import { render, staticRenderFns } from "./IPRestrictionConfig.vue?vue&type=template&id=6c33a261&"
import script from "./IPRestrictionConfig.vue?vue&type=script&lang=ts&"
export * from "./IPRestrictionConfig.vue?vue&type=script&lang=ts&"
import style0 from "./IPRestrictionConfig.vue?vue&type=style&index=0&id=6c33a261&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports